import { addLoading, removeLoading } from '../../../ui/src/actions';
import { fetchArticles } from './../../../ui/src/csm.service';

export const ACTION = {
  LOCATION_ARTICLES_REQUEST: 'LOCATION_ARTICLES_REQUEST',
  LOCATION_ARTICLES_SUCCESS: 'LOCATION_ARTICLES_SUCCESS',
  LOCATION_ARTICLES_FAILURE: 'LOCATION_ARTICLES_FAILURE',
};

export const locationArticlesRequest = locationId => ({
  type: ACTION.LOCATION_ARTICLES_REQUEST,
  payload: {
    locationId,
  },
});

export const locationArticlesSuccess = (
  locationId,
  offset,
  articles,
  nextOffset,
) => ({
  type: ACTION.LOCATION_ARTICLES_SUCCESS,
  payload: {
    locationId,
    offset,
    articles,
    nextOffset,
  },
});

export const locationArticlesFailure = locationId => ({
  type: ACTION.LOCATION_ARTICLES_FAILURE,
  payload: {
    locationId,
  },
});

export const getLocationArticles = (cspace, locationId, extraParams = {}) => {
  return dispatch => {
    dispatch(locationArticlesRequest(locationId));
    dispatch(addLoading());
    return fetchArticles(cspace, extraParams)
      .then(response => {
        dispatch(removeLoading());
        dispatch(
          locationArticlesSuccess(
            locationId,
            extraParams.offset,
            response.articles,
            response.nextOffset,
          ),
        );
        return response;
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(locationArticlesFailure(locationId));
        throw error;
      });
  };
};



// WEBPACK FOOTER //
// ./src/app/container/locationDetail/actions.js